import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/products/all')
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/products?ids=${id}`)
  },

  /**
   * 获取商品分类
   * @param isTop true:顶级分类 false:底级分类 null:全部分类
   */
  getCategoriesAll(isTop?: boolean) {
    let url = '/api/productManagement/categories/all'
    if (isTop != null) {
      url += '?isTop=' + isTop
    }
    return Ajax.get(url)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/products/${id}`
      : '/api/productManagement/products'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/products/${id}`)
  },
  getList(
    pageSize: number,
    currentPage: number,
    keyWord?: string,
    categoryId?: string,
    published?: boolean,
    brandId?: number,
    isTop?: boolean,
    sorting: string = 'creationTime desc'
  ) {
    let params = {
      keyWord: keyWord,
      categoryId: categoryId,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: sorting,
    }
    if (published != null) {
      params['published'] = published
    }
    if (isTop != null) {
      params['isTop'] = isTop
    }
    if (brandId != null) {
      params['brands'] = brandId
    }
    return Ajax.get('/api/productManagement/products', {
      params: params,
    })
  },
  getAttribute(id: string | number) {
    return Ajax.get(`/api/productManagement/products/${id}/productAttribute`)
  },
  getSalesAttribute(id: string | number) {
    return Ajax.get(
      `/api/productManagement/products/${id}/productSalesAttribute`
    )
  },
  /**
   * 获取商品标签列表
   */
  getGoodTag(pageSize: number, currentPage: number) {
    return Ajax.get('/api/productManagement/ProductTag', {
      params: {
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      },
    })
  },
  /**
   * 修改商品上下架
   */
  updatePublished(productIds: [], published: boolean) {
    return Ajax.put('/api/productManagement/products/published', {
      ids: productIds,
      published: published,
    })
  },
  /**
   * 修改商品置顶
   */
  updateIsTop(productIds: [], isTop: boolean) {
    return Ajax.put('/api/productManagement/products/isTop', {
      ids: productIds,
      isTop: isTop,
    })
  },
  /**
   * 复制商品
   */
  copyProduct(id: string) {
    return Ajax.get(`/api/productManagement/products/copy/${id}`)
  },
  /**
   * 批量定时上架
   */
  batchShelf(productIds: any[], beginTime: string, endTime: string) {
    let obj = {
      productIds,
      beginTime,
      endTime,
    }
    return Ajax.put('/api/productManagement/products/TimingPublished', obj)
  },
  /**
   * 匹配商品图片
   * @param ids
   */
  matchProductPictures(ids: string[]) {
    return Ajax.put(`/api/productManagement/products/matchPictures`, ids)
  },
  /**
   * 获取商品销售属性
   * @param id
   */
  getProductSalesAttribute(id: string) {
    return Ajax.get(
      `/api/productManagement/products/${id}/productSalesAttribute`
    )
  },
  /**
   * 导出商品信息
   */
  exportExcel(
    MaxResultCount: number,
    currentPage: number,
    KeyWord?: string,
    ids?: string[],
    CategoryId?: string[],
    Brands?: string[]
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      KeyWord,
      ids,
      CategoryId,
      Brands
    }
    return Ajax.get('/api/productManagement/products/exportProductFile', {
      params: params,
      responseType: "blob"
    })
  },
  // 同步商品
  updateStock(obj: any) {
    return Ajax.post(`/api/GuanYiErpManagement/erpProductStock/updateStock`, obj)
  },
  /**
   * 同步商品库存
   */
  syncAllProductStock() {
    return Ajax.get(`/api/productManagement/thirdParty/product/SyncAllProductStock`)
  }
}
